import React from "react"
import { renderHTML } from "../../agility/utils"
import {
  ObjectiveContainer,
  Wrapper,
  TextContainer,
  ImageContainer,
} from "./styles"
import { Row, Col } from "react-bootstrap"
import ObjectivWaves from "../../img/objective_waves.svg"

const Objective = ({ item }) => {
  return (
    <ObjectiveContainer img={ObjectivWaves}>
      <Wrapper>
        <Row>
          <Col lg={6} md={7}>
            <TextContainer>
              <h3>{item.customFields.title}</h3>
              <div
                dangerouslySetInnerHTML={renderHTML(item.customFields.text)}
              />
            </TextContainer>
          </Col>
          <Col lg={6} md={5}>
            <ImageContainer>
              <img
                src={item.customFields.image.url}
                alt={item.customFields.image.label}
              />
            </ImageContainer>
          </Col>
        </Row>
      </Wrapper>
    </ObjectiveContainer>
  )
}

export default Objective
